// @flow
import { CALL_HISTORY_METHOD, routerActions } from 'react-router-redux';

export default () => next => action => {
  const { type, payload } = action;

  // mapbox-gl-js is set up to use the URL hash to store the current map location.
  // This is not represented as part of the redux state, so we patch it onto the URL
  // when we are transitioning to a new route.
  if (type === CALL_HISTORY_METHOD) {
    const {
      method,
      args: [route, ...args],
    } = payload;

    next(routerActions[method](route + window.location.hash, ...args));
  } else {
    next(action);
  }
};



// WEBPACK FOOTER //
// ./utils/preserveURLHash.middleware.js